import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  tags: { [key: string]: string } = {}
  title: string = ''
  keysToTranslate: string[] = ['og:description', 'description', 'title'];

  constructor(public meta: Meta,
    public titleService: Title,
    private translate: TranslateService,) { }

    setTag(key: string, text: string) {
      if(text == null)
        return
      this.tags[key] = text;
      this.meta.updateTag({ property: key, content: this.tags[key] && this.keysToTranslate.includes(key) ? this.translate.instant(this.tags[key]): this.tags[key] });
    }

    setTitle(text: string) {
      if(text == null)
        return
      this.title = text;
      this.titleService.setTitle(this.title ? this.translate.instant(this.title): '');
    }

    getTag(key: string) {
      if(this.tags[key] != undefined)
        return this.tags[key];
      return '';
    }

    getTitle() {
      return this.title;
    }

    updateLang() {
      this.titleService.setTitle(this.title ? this.translate.instant(this.title): '');
      for(var key of this.keysToTranslate) {
        if(this.tags[key] != undefined)
          this.meta.updateTag({ property: key, content: this.translate.instant(this.tags[key]) });
      }
    }

    setCanonical(url: string) {
      let link: HTMLLinkElement | null = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', url);
    }

    removeCanonical() {
      const link = document.querySelector('link[rel="canonical"]');
      if (link) link.remove();
    }

    setJsonLd(data: object) {
      let script = document.getElementById('json-ld-main') as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = 'json-ld-main';
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.text = JSON.stringify(data);
    }

    removeJsonLd() {
      const script = document.getElementById('json-ld-main');
      if (script) script.remove();
    }

    setHreflang(alternates: { lang: string, url: string }[]) {
      document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
      for (const alt of alternates) {
        const link = document.createElement('link');
        link.setAttribute('rel', 'alternate');
        link.setAttribute('hreflang', alt.lang);
        link.setAttribute('href', alt.url);
        document.head.appendChild(link);
      }
    }

    removeHreflang() {
      document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
    }
}
